// Author → Label handoff via sessionStorage.
//
// The unlabeled reference doesn't live on disk; it's a transient artifact
// that flows from author straight into label mode. Author Save writes the
// just-built JSON here under a per-marc key, then navigates the page to
// `?label={marcId}`. LabelApp consumes the entry on mount (removing it as
// it goes). If there's no handoff (e.g. you reloaded the label tab),
// LabelApp falls back to using the committed reference-{marcId}.json on
// disk as the working copy.
//
// sessionStorage is per-tab and survives the navigation, so the data is
// scoped to "this iteration session" — refreshing the label tab consumes
// the handoff once and then it's gone.

const KEY_PREFIX = "egg-game:v1:handoff:reference-unlabeled:";

export function writeUnlabeledHandoff(marcId, json) {
  try {
    sessionStorage.setItem(KEY_PREFIX + marcId, json);
    return true;
  } catch {
    // Storage full / unavailable. Caller can decide whether to fall back to
    // a download — for now we just signal failure.
    return false;
  }
}

export function consumeUnlabeledHandoff(marcId) {
  try {
    const json = sessionStorage.getItem(KEY_PREFIX + marcId);
    if (json != null) sessionStorage.removeItem(KEY_PREFIX + marcId);
    return json;
  } catch {
    return null;
  }
}
